import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Facebook, Twitter, Instagram, Linkedin, Youtube } from 'lucide-react';
import Button from '../common/Button';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const handleEmailSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle email subscription
    console.log('Email subscription:', email);
    setEmail('');
  };

  const handleSMSSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle SMS subscription
    console.log('SMS subscription:', phone);
    setPhone('');
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo and Social Media */}
        <div className="flex flex-col items-center mb-12">
          <div className="flex items-center mb-6">
            <Mail className="h-8 w-8 text-blue-400" />
            <span className="ml-2 text-xl font-bold">CustMax</span>
          </div>
          <p className="text-gray-400 mb-6 text-center max-w-md">
            AI-powered email marketing platform for global SMBs.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-400 hover:text-white transition-colors transform hover:scale-110">
              <Facebook className="h-7 w-7" />
              <span className="sr-only">Facebook</span>
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors transform hover:scale-110">
              <Twitter className="h-7 w-7" />
              <span className="sr-only">Twitter</span>
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors transform hover:scale-110">
              <Instagram className="h-7 w-7" />
              <span className="sr-only">Instagram</span>
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors transform hover:scale-110">
              <Linkedin className="h-7 w-7" />
              <span className="sr-only">LinkedIn</span>
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors transform hover:scale-110">
              <Youtube className="h-7 w-7" />
              <span className="sr-only">YouTube</span>
            </a>
          </div>
        </div>

        {/* Subscriptions */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl mx-auto mb-16">
          {/* Email Subscription */}
          <div className="bg-gray-800 rounded-lg p-6">
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">
              Newsletter
            </h3>
            <form onSubmit={handleEmailSubscribe} className="space-y-3">
              <div>
                <label htmlFor="email-subscription" className="sr-only">Email</label>
                <input
                  type="email"
                  id="email-subscription"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full px-4 py-2 text-gray-900 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <Button type="submit" variant="primary" size="sm" fullWidth>
                Subscribe to Newsletter
              </Button>
            </form>
          </div>

          {/* SMS Subscription */}
          <div className="bg-gray-800 rounded-lg p-6">
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">
              SMS Updates
            </h3>
            <form onSubmit={handleSMSSubscribe} className="space-y-3">
              <div>
                <label htmlFor="phone-subscription" className="sr-only">Phone</label>
                <input
                  type="tel"
                  id="phone-subscription"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Enter your phone number"
                  className="w-full px-4 py-2 text-gray-900 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <Button type="submit" variant="secondary" size="sm" fullWidth>
                Subscribe to SMS
              </Button>
            </form>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-2xl mx-auto mb-12">
          {/* Product links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4 text-center">
              Product
            </h3>
            <ul className="space-y-2">
              <li className="text-center">
                <Link to="/product" className="text-gray-400 hover:text-white transition-colors">
                  Email Campaigns
                </Link>
              </li>
              <li className="text-center">
                <Link to="/product" className="text-gray-400 hover:text-white transition-colors">
                  Automation
                </Link>
              </li>
              <li className="text-center">
                <Link to="/product" className="text-gray-400 hover:text-white transition-colors">
                  Segmentation
                </Link>
              </li>
              <li className="text-center">
                <Link to="/product" className="text-gray-400 hover:text-white transition-colors">
                  Reporting
                </Link>
              </li>
              <li className="text-center">
                <Link to="/product" className="text-gray-400 hover:text-white transition-colors">
                  AI
                </Link>
              </li>
              <li className="text-center">
                <Link to="/media-world" className="text-gray-400 hover:text-white transition-colors">
                  Media World
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Solutions links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4 text-center">
              Solutions
            </h3>
            <ul className="space-y-2">
              <li className="text-center">
                <Link to="/solutions" className="text-gray-400 hover:text-white transition-colors">
                  Startups
                </Link>
              </li>
              <li className="text-center">
                <Link to="/solutions" className="text-gray-400 hover:text-white transition-colors">
                  Agencies
                </Link>
              </li>
              <li className="text-center">
                <Link to="/solutions" className="text-gray-400 hover:text-white transition-colors">
                  Global
                </Link>
              </li>
              <li className="text-center">
                <Link to="/solutions" className="text-gray-400 hover:text-white transition-colors">
                  B2B
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-gray-700">
          <p className="text-gray-400 text-sm text-center">
            &copy; {new Date().getFullYear()} CustMax, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;